export default __webpack_public_path__ + "static/media/avatar_mice2.f84d0325.mp3";